import { render, staticRenderFns } from "./marketPrice.vue?vue&type=template&id=24a5b1f6&scoped=true&"
import script from "./marketPrice.vue?vue&type=script&lang=js&"
export * from "./marketPrice.vue?vue&type=script&lang=js&"
import style0 from "./marketPrice.vue?vue&type=style&index=0&id=24a5b1f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5b1f6",
  null
  
)

export default component.exports